import { render, staticRenderFns } from "./CalculatorAdministrative.vue?vue&type=template&id=6fc07afe&scoped=true"
import script from "./CalculatorAdministrative.vue?vue&type=script&lang=js"
export * from "./CalculatorAdministrative.vue?vue&type=script&lang=js"
import style0 from "./CalculatorAdministrative.vue?vue&type=style&index=0&id=6fc07afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc07afe",
  null
  
)

export default component.exports